// extracted by mini-css-extract-plugin
export default {"inputContainer":"customInput_inputContainer__jG9DL"};